import { render } from "./News_page.vue?vue&type=template&id=7c7e38a4&scoped=true"
import script from "./News_page.vue?vue&type=script&lang=js"
export * from "./News_page.vue?vue&type=script&lang=js"

import "./News_page.vue?vue&type=style&index=0&id=7c7e38a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c7e38a4"

export default script